import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  SimpleForm,
  TextInput,
  required,
  maxLength,
  SelectInput,
  Edit,
} from 'react-admin';
import { Grid } from '@mui/material';
import EditToolBar from '../../../components/commons/editToolBar';
import EditActions from '../../../components/commons/editActions';
import FUNC from '../../../utils/functions';
import canAccess from '../../../utils/canAccess';

export default React.memo(() => {
  const { faculties } = useSelector((state: any) => state.subjects);
  const { permissions } = useSelector((state: any) => state.app.appState);

  const canEdit = canAccess(permissions, FUNC.EDIT_SUBJECT);
  const canSearch = canAccess(permissions, FUNC.SEARCH_SUBJECTS);
  const canShow = canAccess(permissions, FUNC.SHOW_SUBJECT_DETAIL);
  return (
    <Edit
      actions={<EditActions isShow={canShow} isList={canSearch} />}
      mutationMode="pessimistic"
      transform={(data: any) => {
        data.code = data.subjectCode;
        return data;
      }}
    >
      <SimpleForm toolbar={<EditToolBar isSave={canEdit} />}>
        <Grid container spacing={2} rowSpacing={0.5}>
          <Grid item md={1} />
          <Grid item xs={12} md={10}>
            <SelectInput
              source="facultyId"
              choices={faculties ?? []}
              emptyValue=""
              fullWidth
              optionText={(choice) => choice.name}
              variant="outlined"
              helperText={false}
              validate={
                required()
              }
            />
          </Grid>
          <Grid item md={1} />
          <Grid item md={1} />
          <Grid item xs={12} md={5}>
            <TextInput
              fullWidth
              variant="outlined"
              source="subjectCode"
              disabled
              validate={[
                required(),
                maxLength(10),
              ]}
              helperText={false}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TextInput
              source="name"
              fullWidth
              variant="outlined"
              helperText={false}
              validate={[
                required(),
                maxLength(100),
              ]}
            />
          </Grid>
          <Grid item md={1} />
          <Grid item md={1} />
          <Grid item xs={12} md={10}>
            <TextInput
              fullWidth
              multiline
              variant="outlined"
              source="description"
              validate={[
                maxLength(200),
              ]}
              helperText={false}
            />
          </Grid>
          <Grid item md={1} />
        </Grid>
      </SimpleForm>
    </Edit>
  );
});
